import React, {useEffect, useState} from 'react';
import BarChart from "../../../../etc/BarChart";

const JDepartments = (parent) => {
	const record = parent.record;

	if(!record.journal_dept_graph || record.journal_dept_graph.length <= 0)
		return ''

	record.journal_dept_graph.map((item,key) => {
		record.journal_dept_graph[key].key = key;
	});

	useEffect(() => {
		changeData();
	}, []);

	const changeData = () => {
		// setData(datas[i++]);
		// if (i === datas.length) i = 0;
	}

	return (
		<div className="mt-65 journal-detail-departments">
			<div className="d-flex justify-content-between align-items-center mb-px-26">
				<div className="d-flex align-items-center">
					<h3 className="con-title">주요 등재 학과</h3>
				</div>
			</div>
			<div>
				<BarChart width={840} height={820} data={record.journal_dept_graph}/>
			</div>
		</div>
	);
};

export default JDepartments;
